import { Invite } from '../../models/invite';
import { Component, OnInit, EventEmitter, Output, Input, forwardRef } from '@angular/core';
import { VenueService } from '../../services/venue.service';
import { RequestOptions, Headers, Http} from '@angular/http';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { environment } from '../../../environments/environment';
import { CompleterService, CompleterData, RemoteData  } from 'ng2-completer';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

const noop = () => {
};

export const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => OfferCompleterComponent),
    multi: true
};

@Component({
  selector: 'app-offer-completer',
  templateUrl: './offer-completer.component.html',
  styleUrls: ['./offer-completer.component.css'],
  styles: [`:host >>> .completer-dropdown {
              overflow-y: auto;
              max-height: 400px;
            }`],
  providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
})
export class OfferCompleterComponent implements OnInit, ControlValueAccessor {

  private innerValue: any = '';

  remote: RemoteData;
  title:string;
  id:string;
  url:string;
  offer:any;

  @Input() disabled:boolean;
  @Input() invite:boolean;
  @Output() offerData = new EventEmitter();
  @Input() idjob;


  private onTouchedCallback: () => void = noop;
  private onChangeCallback: (_: any) => void = noop;


  constructor(private completerService: CompleterService,
  private auth:AuthService,
  private req: RequestOptions

) {
    // UploadFile
  }

    ngOnInit() {
    if(this.invite === false){
      this.url = `/job/?light=1&pagecount=1000&query=`;
    }else{
      this.url = `/job/?light=1&pagecount=1000&premium=1&query=`;
    }
    let header = new Headers();
    header.append('Content-Type', 'application/json');
    header.append('X-API-KEY', environment.apiKey);
    header.append('X-ACCESS-TOKEN', this.auth.idToken);
    this.req = new RequestOptions({headers: header});

    this.remote = this.completerService.remote(null, "title_venue", "title_venue");
    this.remote.urlFormater(term => {
            return environment.apiRoot+this.url+`${term}`;
        });
    this.remote.requestOptions(this.req);
    this.remote.dataField("data.jobs");
  }

  get value(): any {
        return this.innerValue;
  };

  set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.onChangeCallback(v);
        }
  }
  registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
  registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
  }

  writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
  }

  onSelected($event){
    if ($event){
      this.id = $event.originalObject.id;
      this.title = $event.title;
    }else{
      this.title = null;
      this.id = null;
    }
    this.offerData.emit(
      {
        id: this.id,
        title:this.title,
      }
    );
  }

}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/offer-completer/offer-completer.component.ts